export default {
  banner: {
    title: '成图软件建构者',
    items: [
      '为客户研发业内领先的生产力工具软件',
      '基于生产力工具软件提供生产工艺改进服务',
      '通过生产工艺改进助力智慧型地理数据工厂建设'
    ]
  },
  login: {
    title: '账户密码登录',
    scanTitle: '二维码登录',
    codeTitle: '手机号登录',
    logIn: '登录',
    register: '注册',
    username: '请输入用户名或手机号码',
    password: '请输入密码',
    rule: '用户名或手机号',
    version: '版本',
    upper: '大写已锁定',
    scanTip: 'APP扫码登录',
    accountTip: '请输入账号',
    passwordTip: '请输入密码',
    codeTip: '请输入验证码',
    changeCode: '点击切换验证码',
    mobile: '请输入手机号',
    rightMobile: '请输入正确的手机号',
    smsCode: '请输入验证码',
    getCode: '获取验证码',
    reSend: '重新发送',
    company: '请输入公司名',
    contacts: '请输入联系人',
    ForgetPassword: '忘记密码',
    confirmPassword: '请确认密码',
    newPassword: '请输入新密码',
    confirmNewPassword: '请确认新密码',
    sendSuccess: '发送成功',
    loginFailed: '登录失败',
    secondsResend: '秒后重新发送',
    resendCode: '重新发送验证码',
    firstScanTip: '温馨提示：第一次扫码登陆需要绑定手机号。',
    submit: '提交',
  },
  register: {
    gender: '请输入正确性别',
    rightMobile: '请输入正确手机号码',
    username: '请输入正确格式的账号：字母、数字组成',
    name: '请输入正确姓名',
    organization: '请选择所在组织',
    password: '请输入正确的密码格式',
    organizationTitle: '请输入正确的组织名称'
  },
  home: {
    productIntro: '创新方案 • 赋能行业场景落地应用',
    Industry: '行业应用',
    productAdvantage: '产品矩阵•构筑数据治理智慧工厂',
    productAdvantageintroDes: '核心产品优势',
    getServices: '获取最新Summit系列产品及服务',
    clickButton: '点击获取',
    toolPlatform: '空间数据处理工具平台',
    ViewDetails: '查看详情',
    IPR: '自主知识产权',
    patent: '发明专利',
    Ratio: '研发人员占比',
    requirement: '聊聊您的项目规划',
    solutions: '我们提供专业解法',
  },
  product: {
    Features: '功能特性',
    function: '功能对比',
    Competitor: '竞品对比',
    otherFlag: '其他产品',
    ourFlag: '我们',
    vs: 'Summit vs 同类产品',
  },
  Buy: {
    // 顶部区域
    priceSectionTitle: "选中您的订阅产品",

    // 产品卡片
    hotTag: "热销功能",
    buyNow: "立即购买",
    DownloadNow: "立即下载",
    learnMore: "了解更多",

    // 定价方案
    contactSales: "联系客服",
    perWeek: "/周起",
    freeUse: "免费使用",
    freeTrialTag: "免费试用",
    coreFeatures: "核心要点",

    // 功能对比
    featureComparison: "功能对比",

    // 系统配置
    SystemConfiguration: "系统配置",
    operatingSystem: "操作系统",
    entryConfig: "标准配置",
    recommend: "推荐",
    recommendConfig: "推荐配置",

    // 订阅指南
    subscribeGuide: "订阅指南",
    noContent: "暂无内容",
    loadFailed: "加载失败，请重试",

    // 常见问题
    faqTitle: "常见问题",
    faqSubtitle: "快速找到您需要的答案",

    // 提示消息
    selectProductFirst: "请先选择要结算的商品",
  },

  Service: {
    // 常见问题
    faqTitle: "常见问题",

    // 搜索横幅
    searchBannerTitle: "欢迎使用峰岭科技服务与支持",
    searchPlaceholder: "请输入您想了解的问题",
    searchButton: "查询",

    // 功能卡片
    videoTitle: "操作视频",
    downloadTitle: "资源下载",
    allTitle: "全部",
    manualTitle: "操作手册",
    newsTitle: "更新日志",
    mediaTitle: "宣传视频",

    // 热点问题
    hotQuestionsTitle: "常见问题",
    viewMore: "查看更多",

    // 客户服务
    contactUsTitle: "客户服务",
    contactPhone: "客服电话",
    companyAddress: "公司地址",
    companyAddressValue: "",
    companyAddressValueEn: "",
    email: "电子邮箱",
    wechatQrcode: "企业微信",
    qrcodeScan: "扫一扫",
    qrcodeServiceTip: "获取专属客户服务",

    // 反馈表单
    feedbackTitle: "客服·意见建议",
    feedbackSubtitle: "如有任何问题或建议，请填写以下表单，我们将尽快回复您",
    nameLabel: "姓名",
    namePlaceholder: "请输入您的姓名",
    nameRequired: "请输入您的姓名",
    emailLabel: "邮箱",
    emailPlaceholder: "请输入您的邮箱",
    emailRequired: "请输入您的邮箱",
    emailFormat: "请输入正确的邮箱格式",
    subjectLabel: "主题",
    subjectPlaceholder: "请输入主题",
    subjectRequired: "请输入主题",
    contentLabel: "内容",
    contentPlaceholder: "请详细描述您的问题或建议...",
    contentRequired: "请输入反馈内容",
    tip: "* 我们将在1-3个工作日内回复您",
    submitButton: "提交反馈",
    feedbackSuccess: "反馈提交成功，感谢您的宝贵意见！",
    feedbackError: "提交失败，请稍后重试",
  },
  message: {
    sendSuccess: '发送成功',
    deleteSuccess: '删除成功',
    saveSuccess: '保存成功',
    Feedbacksus: '反馈提交成功，我们会尽快回复您！',
    Feedbackerr: '提交失败，请稍后重试',
  },
  menu: {
    home: '首页',
    products: '产品介绍',
    buy: '按需订阅',
    freeSoft: '免费软件',
    service: '服务支持',
    about: '关于我们',
    customerService: '联系客服',
    cart: '购物车',

    titles: {
      SummitMap: '一站式智能成图平台',
      SummitSolid: '一站式单体化系统',
      SummitLab: '智能化内业培训系统',
      SummitTerra: '智能化内业培训系统',
      softwareSupport: '软件支持',
      qa: '问题交流',
      contact: '联系我们',
      companyIntro: '企业介绍',
      culture: '企业文化',
      honors: '荣誉资质'
    },

    content: {
      summitMapDesc: '点云版本、倾斜版、立体航测版',
      support: '教学视频',
      contactInfo: '联系方式'
    }
  },
  header: {
    login: '登录',
    logout: '退出',
    userAuth: '用户认证',
    orderManage: '订单管理',
    licenseApply: '许可证申请',
    invoiceManage: '发票管理',
    invoiceProfile: '开票信息维护'
  },
  guide: {
    entryTip: '新手引导',
    next: '下一步',
    prev: '上一步',
    done: '完成',
    goNext: '去下一步',
    stepPersonalTitle: '第一步：进入个人中心',
    stepPersonalDesc: '点击「进入个人中心查看」，在这里管理您的订单、许可证和发票。',
    stepOrderTitle: '第二步：下载已购软件',
    stepOrderDesc: '在「订单管理」中找到对应订单，点击「下载」即可获取已购软件的安装包与下载链接。',
    stepLicenseTabTitle: '第三步：进入许可证申请',
    stepLicenseTabDesc: '点击左侧「许可证申请」，为已购产品生成使用许可。',
    stepLicenseTitle: '第四步：创建许可证',
    stepLicenseDesc: '点击「创建许可证」，开始为您的电脑生成专属许可。',
    stepMachineTitle: '第五步：输入机器码',
    stepMachineDesc: '打开软件在许可信息弹窗中获取机器ID，填入此处即可生成许可证。',
    stepScanTitle: '手机扫码申请许可流程',
    stepScanDesc: '可使用手机扫描下图所示流程完成许可证申请。',
    stepLicenseMobile: '手机端也能同步完成此操作，扫描下方二维码即可在手机上继续：'
  },
  footer: {
    address: '地址',
    addressValue: '湖北省武汉市高新大道999号未来科技城B区1栋2楼',
    phone: '电话',
    email: '邮箱',
    softwareSupport: '软件支持',
    qa: '问题交流',
    customerService: '客户服务',
    contactUs: '联系我们',
    companyIntro: '企业介绍',
    culture: '企业文化',
    honors: '荣誉资质',
    companyMap: '公司地图',
    joinUs: '加入我们',
    wechatPlatform: '峰岭官网公众号',
    officialVideo: '峰岭官方视频号',
    douyingVideo: '峰岭官方抖音号',
    icp: '鄂ICP备2022010992号-1'
  },
  aboutUs: {
    // Banner区域
    mainTitle: "成图软件建构者",
    subTitle: "SUMMITEK LTD.",
    ipRights: "自主知识产权",
    inventionPatents: "发明专利",
    rdRatio: "研发人员占比",
    introParagraph1: "武汉峰岭科技成立于2020年，位于武汉未来科技城，是一家专注国产化空间数据治理平台研发的高新技术企业",
    introParagraph2: "依托自研SummitSDK技术体系，公司构建了Summit、Lab、Flow三大生产力工具软件产品家族，并为行业用户提供电力、测绘、自然资源等丰富领域专属解决方案",
    introParagraph3: "致力于成为空间数据治理软件行业隐形冠军，全面释放地理信息数据潜能，赋能国家重大工程建设",

    // 企业文化
    vision: "愿景",
    visionText: "成图软件建构者",
    concept: "理念",
    conceptText1: "细节铸就产品　服务赢取市场",
    conceptText2: "规则定义底线　文化确立上限",
    mission: "使命",
    missionText1: "为客户研发业内领先的生产力工具软件",
    missionText2: "基于生产力工具软件提供生产工艺改进服务",
    missionText3: "通过生产工艺改进助力智慧型地理数据工厂建设",
    coreValues: "核心价值观",
    coreValuesText1: "每个人通过自己的努力",
    coreValuesText2: "都能获取合理的报酬和有尊严的生活",

    // 荣誉资质
    honorsDesc1: "公司始终将",
    honorsHighlight1: "自主研发创新",
    honorsDesc2: "视为高质量发展的核心与灵魂",
    honorsDesc3: "凭借强大研发实力先后取得多项行业代表性",
    honorsHighlight2: "资质荣誉",
    honorsDesc4: "拥有",
    honorsHighlight3: "自主知识产权50余项，发明专利11项",
    honorsDesc5: "，并以每年新增2~3项发明专利的速度快速构建自有技术保护体系",

    // 证书名称
    certSpecialized: "专精特新企业",
    certGazelle: "光谷瞪羚企业",
    certHighTech: "高新技术企业",
    certSoftware: "软件著作权",
    certPatent: "发明专利",
    certSurveyingB: "乙级测绘资质证书",
    certGazelleShort: "光谷瞪羚",
    certQualitySystem: "质量体系管理认证",
    certWuhanAi: "武汉市人工智能库",
    certGisEval: "地理信息相关软件测评证书",
    certInnovativeProduct: "测绘地理信息自主创新产品",
    certInnovationContest: "创新创业大赛优秀奖",
    certSoftwareShort: "软著",
    certHunanGrand: "湖南特等奖",
    certShandongAward: "山东自然资源科学技术奖",
    certSoftwareAssoc: "省软件协会会员单位",
    certReal3dEval: "实景三维测评证书",

    // 联系我们
    contactUs: "联系我们",
    contactUsText: "CONTACT US",
  },
  SubscribeDialog: {
    // 时长单位
    durationUnit: "时长单位",
    week: "周",
    month: "月",
    quarter: "季",
    halfyear: "半年",
    recommend: "推荐",
    only: "仅需",
    perDay: "元/日",

    // 订阅设置
    subscribeDuration: "订阅时长",
    softwareQuantity: "软件数量",
    total: "合计",

    // 按钮
    subscribeNow: "立即订阅",

    // 协议
    agreementText: "我已阅读并同意",
    productAgreement: "《产品订阅须知》",
    licenseAgreement: "《峰岭科技个人计算机软件许可协议》",
    scrollToAgree: "滚动到底部可同意",
    haveRead: "我已阅读",

    // 提示
    pleaseAgreeFirst: "请先阅读并同意相关协议",
  },

  OrderConfirmDialog: {
    // 支付成功
    paymentComplete: "您的支付已完成",
    viewInUserCenter: "个人中心查看",

    // 收货信息
    receiverInfo: "用户信息",
    name: "姓名",
    namePlaceholder: "请输入姓名",
    nameRequired: "请输入姓名",
    phone: "手机号",
    phonePlaceholder: "请输入手机号",
    phoneRequired: "请输入手机号",
    phoneInvalid: "请输入正确的手机号",
    email: "邮箱",
    emailPlaceholder: "请输入邮箱",
    emailRequired: "请输入邮箱",
    emailInvalid: "请输入正确的邮箱格式",
    company: "公司",
    companyPlaceholder: "请输入公司名称",
    companyRequired: "请输入公司名称",
    editUserInfo: "修改",
    editUserInfoTitle: "修改用户信息",
    userInfoSaveSuccess: "用户信息已保存",
    userInfoSaveFailed: "保存失败，请稍后重试",

    // 订单信息
    confirmOrderInfo: "确认订单信息",
    productInfo: "产品信息",
    productDetail: "产品详情",
    purchaseDuration: "购买时长",
    purchaseQuantity: "购买数量",
    price: "价格",
    inviteCodeDiscount: "邀请码抵扣",

    // 邀请码
    inviteCode: "邀请码",
    inviteCodePlaceholder: "请输入邀请码",
    inviteCodeInvalid: "邀请码无效或无对应匹配产品",
    inviteCodeSuccess: "邀请码校验成功，已生效折扣",
    inviteCodeFailed: "邀请码校验失败",
    inviteCodeChangedNeedReconfirm: "邀请码折扣已更新，请重新点击确定以生成新的支付二维码",

    // 发票
    invoice: "发票",
    needInvoice: "我需要开具发票",
    invoiceType: "发票类型",
    electronicInvoice: "电子普通发票",
    vatInvoice: "增值税电子普通发票",
    headerType: "抬头类型",
    personal: "个人",
    enterprise: "企业",
    invoiceHeader: "发票抬头",
    selectInvoiceHeader: "请选择发票抬头",
    pleaseSelectInvoiceHeader: "请选择发票抬头",

    // 订单备注
    orderRemark: "订单备注",
    orderRemarkPlaceholder: "选填，请输入订单备注",

    // 按钮
    confirm: "确定",
    cancel: "取消",

    // 付款详情
    paymentDetails: "付款详情",
    totalProducts: "共 {count} 件产品",
    productTotal: "商品总价",
    total: "合计",

    // 支付
    scanToPay: "请使用扫码支付",
    scanToPayTip: "请扫码支付",
    payNow: "立即支付",
    paying: "支付中...",

    // 支付方式
    alipay: "支付宝",
    wechat: "微信",
    unionpay: "银联",
    creditCard: "信用卡",

    // 提示消息
    orderSuccess: "下单成功，请扫码支付",
    orderFailed: "下单失败",
    orderError: "下单异常，请重试",
    getQrcodeFailed: "获取支付二维码失败，请稍候重试",
    orderIdMissing: "订单号缺失，请先确认订单",
    paymentCompleted: "支付已完成",
    paymentNotDetected: "暂未检测到支付，请扫码完成支付后再试",
    queryPaymentFailed: "查询支付状态失败",
    payingInProgress: "支付进行中，请稍候",
    missingOrderId: "缺少订单号，请联系后台",
  },

  ShoppingCartDialog: {
    // 标题
    title: "购物车",

    // 列表
    purchaseDuration: "购买时长",
    delete: "删除",

    // 空状态
    emptyCart: "购物车是空的",

    // 结算
    settlementDetails: "结算明细",
    totalProducts: "共{count}件产品",
    total: "合计",
    settle: "结算",

    // 时长单位
    week: "周",
    month: "月",
    quarter: "季",
    halfyear: "半年",
  },
}
